import { TContentType } from "@/contexts/globalSearch";

export const contentTypesNiceName = (type: TContentType) => {
  switch (type) {
    case "Post":
      return "Publications & actualités";
    case "Page":
      return "L'établissement";
    case "Operation":
      return "Opérations";
    case "Event":
      return "Événements";
    default:
      return type;
  }
};

export const contentTypesNiceNameSingular = (type: TContentType) => {
  switch (type) {
    case "Post":
      return "Publication / actualité";
    case "Page":
      return "L'établissement";
    case "Operation":
      return "Opération";
    case "Event":
      return "Événement";
    default:
      return type;
  }
};
